module.exports = "<router-outlet></router-outlet>\n\n"


//////////////////
// WEBPACK FOOTER
// /Users/dearmom/Sites/portfolio/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main